import { SIGN_OUT } from 'Global/Stores/auth'

const PREVIEW_MODAL_GENERIC_EXPANSION_TOGGLE = 'PREVIEW_MODAL/GENERIC/EXPANSION/TOGGLE'
const PREVIEW_MODAL_GENERIC_INDEX_SET = 'PREVIEW_MODAL/GENERIC/INDEX/SET'
const PREVIEW_MODAL_GENERIC_TOGGLE = 'PREVIEW_MODAL/GENERIC/PREVIEW/TOGGLE'

export const previewModalIndexSet = index => ({
  payload: index,
  type: PREVIEW_MODAL_GENERIC_INDEX_SET,
})

export const previewModalExpansionToggle = () => ({
  type: PREVIEW_MODAL_GENERIC_EXPANSION_TOGGLE,
})

export const previewModalToggle = index => ({
  payload: index,
  type: PREVIEW_MODAL_GENERIC_TOGGLE,
})

const initialState = {
  expanded: false,
  index: 0,
  visible: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case PREVIEW_MODAL_GENERIC_EXPANSION_TOGGLE:
      return {
        ...state,
        expanded: !state.expanded,
      }

    case PREVIEW_MODAL_GENERIC_INDEX_SET:
      return {
        ...state,
        index: payload,
      }

    case PREVIEW_MODAL_GENERIC_TOGGLE:
      return {
        ...state,
        index: typeof payload === 'number' && payload > -1 ? payload : -1,
        visible: !state.visible,
      }

    case '@@router/LOCATION_CHANGE':
      return initialState

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
